/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import { wrapRootElement as wrap } from "./rootWrapper"
export const wrapRootElement = wrap
